export enum ClauseType {
  RODO = 1,
  RemoteWork = 2,
  PPK = 3
}
